import React, { ReactNode } from 'react';

import './results__table.scss';

interface Props {
    children: ReactNode;
}

const Table = ({ children }: Props) => {
    return <div className="results__table">{children}</div>;
};

export default Table;
